export default __webpack_public_path__ + "assets/6ae4804f738019ccff2cd4e686665440.svg";